import React, { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { Button } from '@folio/stripes/components';
import { useStripes } from '@folio/stripes/core';
import { VOCABULARY_TYPES_CAPABILITY } from '../utils/settingsAccess';
var VOCABULARY_TYPES_PATH = '/czna-authorities/vocabulary-types';
/**
 * Settings nav button for Nastavení → Slovníky (CZNA-1470). Mirrors
 * `DerivationRulesNavButton`; shown to whoever may create a vocabulary — the
 * vocabulary administrator and the authority administrator (UX gate; server enforces).
 */
var VocabularyTypesNavButton = function () {
    var history = useHistory();
    var pathname = useLocation().pathname;
    var intl = useIntl();
    var stripes = useStripes();
    var handleClick = useCallback(function () {
        if (pathname !== VOCABULARY_TYPES_PATH)
            history.push(VOCABULARY_TYPES_PATH);
    }, [history, pathname]);
    if (!stripes.hasPerm(VOCABULARY_TYPES_CAPABILITY))
        return null;
    var isActive = pathname === VOCABULARY_TYPES_PATH || pathname.startsWith("".concat(VOCABULARY_TYPES_PATH, "/"));
    return (React.createElement(Button, { onClick: handleClick, buttonStyle: isActive ? 'primary' : 'default', fullWidth: true, marginBottom0: true, style: { justifyContent: 'flex-start' }, "aria-current": isActive ? 'page' : undefined, "data-testid": "settings-nav-vocabulary-types" },
        React.createElement("span", { style: { marginLeft: '0.5rem' } }, intl.formatMessage({ id: 'ui-czna-authorities.navigation.vocabularyTypes' }))));
};
export default VocabularyTypesNavButton;
